import styled from 'styled-components';

export const TrainMarginContainer = styled.div`
  border: 1px solid black;
  padding: 8px;
`;

export const TrainMarginTable = styled.table`
  background: black;
  width: 100%;
  border-spacing: 1px;
`;

export const TrainMarginHead = styled.thead`
  background: white;
`;

export const TrainMarginBody = styled.tbody`
  background: white;
  text-align: center;
`;
